import { BookSeries } from "./book-series";
import { bindSeriesConfirmModal, renderSeriesSavings } from "./series-confirm-modal";
import { formatMoney } from "./g-utils";
import { CarouselManager } from "../utils/carouselManager";

class SeriesCarousel extends BookSeries {
  constructor() {
    super();

    this.modal = this.querySelector("series-carousel-modal");
    this.init = false;
  }

  async connectedCallback() {
    this.modal = bindSeriesConfirmModal(this);

    document.documentElement.addEventListener("cart:rerender", () => {
      clearTimeout(this.cartTimoutId);
      this.cartTimoutId = setTimeout(this._fetchItems.bind(this), 1000);
    });

    this._initSlider();
    super.connectedCallback();
  }

  async _updateContent() {
    this.setAttribute("aria-busy", true);

    const carouselItems = this.querySelector(".js-carousel-items");
    const modalItems = this.querySelector(".js-modal-items");
    const totalPriceEls = this.querySelectorAll(".js-total-price");
    const booksCountEls = this.querySelectorAll(".js-books-count");
    const newCarouselItems = document.createElement("DIV");
    const newModalItems = document.createElement("DIV");
    let newTotalPrice = 0;
    let newTotalCompareAt = 0;
    let newBooksCount = 0;

    for (const batch of this._sectionBatches) {
      const curCarouselItems = batch.querySelector(".js-carousel-items");
      const curModalItems = batch.querySelector(".js-modal-items");
      const curTotalPrice =
        parseInt(batch.querySelector(".js-total-price")?.dataset.totalPrice) || 0;
      const curTotalCompareAt =
        parseInt(batch.querySelector(".js-total-price")?.dataset.totalCompareAt) || 0;
      const curBooksCount =
        parseInt(batch.querySelector(".js-books-count")?.dataset.booksCount) || 0;

      newCarouselItems.insertAdjacentHTML("beforeend", curCarouselItems.innerHTML);
      newModalItems.insertAdjacentHTML("beforeend", curModalItems.innerHTML);
      newTotalPrice += curTotalPrice;
      newTotalCompareAt += curTotalCompareAt;
      newBooksCount += curBooksCount;
    }

    const seriesSize = this._retailCollection.productIds?.length || 0;
    if (newBooksCount === 0) {
      this.setAttribute("aria-hidden", true);
      return;
    }
    this.setAttribute("aria-hidden", false);

    carouselItems.innerHTML = newCarouselItems.innerHTML;
    this.init = true;
    if (this.splide) {
      this.splide.refresh();
    }
    modalItems.innerHTML = newModalItems.innerHTML;
    totalPriceEls.forEach((el) => (el.textContent = formatMoney(newTotalPrice)));
    renderSeriesSavings(this, newTotalPrice, newTotalCompareAt);
    this.querySelectorAll(".js-total-books-count").forEach((el) => {
      el.textContent = seriesSize;
    });
    booksCountEls.forEach((el) => (el.textContent = newBooksCount));

    this.setAttribute("aria-busy", false);
  }

  async _initSlider() {
    const splideEl = this.querySelector(".splide");

    let options = {
      arrows: false,
      drag: "free",
      pagination: false,
      perPage: 5,
      authHeight: true,
      gap: 16,
      breakpoints: {
        640: {
          destroy: true
        },
        768: {
          perPage: 3,
        },
        900: {
          perPage: 2,
        },
        1140: {
          perPage: 3,
        },
        1280: {
          perPage: 4,
        },
      }
    };

    this.splide = await CarouselManager.create(splideEl, options);

    if (this.dataset.arrows === "true") {
      this._initSliderArrows();
    }
  }

  _initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

      const maxIndex = () => {
        const maxIndex = this.splide.Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.splide.Components.Controller.getIndex();
        
        if(maxIndex === currentIndex) {
          return true;
        } else if(maxIndex < currentIndex) {
          this.splide.Components.Controller.setIndex(maxIndex);
          return true;
        } else {
          return false;
        }
      }

      navNextBtn.addEventListener("click", () => {
        if(maxIndex()) return;
        this.splide.go(">");
      });

      navPrevBtn.addEventListener("click", () => {
        maxIndex();
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }

  get visibleSlides() {
    if (!this.splide) return 1;
    if(!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length
    }
    return this._visibleSlides;
  }

  get productId() {
    return this.dataset.productId;
  }
}

if (!customElements.get("series-carousel")) {
  customElements.define("series-carousel", SeriesCarousel);
}
